import React, { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { CRBN_ORANGE_LOGO } from "@shared_components/const_paths"
import {TemporaryPanel, UsageData } from "../types";

export const AiDesignNavbar = () => {
  const { pathname } = useLocation();
  const normalizePath = (path: string) => path.replace(/\/+$/, "");
  const currentPath = normalizePath(pathname);
  const linkBaseClass = "transition-opacity";
  const disabledLinkClass = "pointer-events-none opacity-50 cursor-not-allowed";
  const isActive = (path: string) => currentPath === normalizePath(path);

  return (
    <div className="flex w-full bg-black text-white items-center justify-between px-2  h-14 owndesign_navbar text-xs sm:text-sm md:text-base md:px-4">
      <div className="owndesign_logo_container">
        <div className="owndesign_navbar_top_logo">
          <img src={CRBN_ORANGE_LOGO} alt="logo" className="w-[125px] md:w-[225px] h-auto pr-4" />
        </div>
      </div>
      <div className="flex flex-row gap-4 items-center md:gap-8">
        <Link
          to="/designs/ai-design/new/"
          className={`${linkBaseClass} ${isActive("/designs/ai-design/new/") ? disabledLinkClass : ""}`}
          aria-disabled={isActive("/designs/ai-design/new/")}
          tabIndex={isActive("/designs/ai-design/new/") ? -1 : 0}
        >
          Create New
        </Link>
        <Link
          to="/designs/ai-design/history/"
          className={`${linkBaseClass} ${isActive("/designs/ai-design/history/") ? disabledLinkClass : ""}`}
          aria-disabled={isActive("/designs/ai-design/history/")}
          tabIndex={isActive("/designs/ai-design/history/") ? -1 : 0}
        >
          Previous Entries
        </Link>
      </div>
      <div className="owndesign_navbar_rightcorner">
        <a
          href="/designs/"
          className={`${linkBaseClass} ${isActive("/designs/") ? disabledLinkClass : ""}`}
          aria-disabled={isActive("/designs/")}
          tabIndex={isActive("/designs/") ? -1 : 0}
        >
          Back to Designs
        </a>
      </div>
    </div>
  )
}





type CountdownTimerProps = {
  usage: UsageData;
  variant?: "default" | "gearstudio";
};

export const CountdownTimer = ({ usage, variant = "default" } : CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<string>("");

  useEffect(() => {
    const calculateTime = () => {
      const start = new Date(usage.usage_reset_time);
      const target = new Date(start.getTime() + (24 * 60 * 60 * 1000));
      const now = new Date();
      const diff =   target.getTime() - now.getTime();

      if (diff <= 0) {
        setTimeLeft(""); // Timer finished
        return;
      }

      // Calculate hours and minutes left
      const hours = Math.floor((diff / (1000 * 60 * 60)));
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      
      setTimeLeft(`${hours}h ${minutes}m`);
    };

    // Update every minute
    calculateTime();
    const timer = setInterval(calculateTime, 60000);

    return () => clearInterval(timer);
  }, [usage.usage_reset_time]);


  if (!usage || usage.daily_limit === 0) return <span></span>; // No limit info available

  const containerClass = variant === "gearstudio"
    ? "rounded-[var(--gs-radius-input)] border border-[color:var(--gs-border-subtle)] bg-[color:var(--gs-bg-surface-alt)] px-3 py-2"
    : "bg-yellow-100 text-yellow-800 p-2 rounded";
  const primaryTextClass = variant === "gearstudio" ? "font-semibold text-[var(--gs-text-primary)]" : "font-medium";
  const secondaryTextClass = variant === "gearstudio" ? "ml-4 text-[var(--gs-text-secondary)]" : "ml-4";

  return (
    <div className={containerClass}>
      <span className={primaryTextClass}>Usage: {usage.usage_count} / {usage.daily_limit}</span>
      {timeLeft && <span className={secondaryTextClass}>Resets in: {timeLeft}</span>}
    </div>
  );
};
